import { RepairCost, RepairCostFormValues } from './type';
import moment from 'moment';

export const repairCostToFormInitialValues = (repairCost: RepairCost | null): RepairCostFormValues => ({
  repairCostId: repairCost?.id ?? null,
  quote: repairCost?.quote
    ? {
        number: repairCost.quote.number,
        date: moment(repairCost.quote.date),
        cost: repairCost.quote.cost != null ? repairCost.quote.cost + '' : null,
        fileName: repairCost.quote.fileName,
      }
    : null,
  order: repairCost?.order
    ? {
        number: repairCost.order.number,
        date: moment(repairCost.order.date),
        cost: repairCost.order.cost != null ? repairCost.order.cost + '' : null,
        fileName: repairCost.order.fileName,
      }
    : null,
  invoice: repairCost?.invoice
    ? {
        number: repairCost.invoice.number,
        date: moment(repairCost.invoice.date),
        cost: repairCost.invoice.cost != null ? repairCost.invoice.cost + '' : null,
        fileName: repairCost.invoice.fileName,
        status: repairCost.invoice.status,
      }
    : null,
  rebillable: repairCost?.rebillable ?? null,
  rebilling: repairCost?.rebilling
    ? {
        type: repairCost.rebilling.type,
        precision: repairCost.rebilling.precision,
        number: repairCost.rebilling.number,
        date: moment(repairCost.rebilling.date),
        providerOrderNumber: repairCost.rebilling.providerOrderNumber,
      }
    : null,
  comment: repairCost?.comment ?? null,
});
